module.exports = __webpack_public_path__ + "static/imagem-03-equipamentos-d7bdc87f8ce79db1e9520428f9e11451.jpg";